module.exports = __webpack_public_path__ + "img/19-s.9b15c0ec.png";